import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type CollectionProps = {
  collectionList: any
  collectionMore: boolean
  roleCollectionList: any
  roleCollectionTotal: number
  allCard: {
    perception: any
    judge: any
    action: any
    social: any
    individuality: any
    insane: any
  }
  userScore: {
    perception: number
    judge: number
    action: number
    social: number
    individuality: number
    insane: number
  }
}

const initialState = {
  collectionList: [],
  collectionMore: false,
  roleCollectionList: [],
  roleCollectionTotal: 0,
  allCard: {
    perception: {},
    judge: {},
    action: {},
    social: {},
    individuality: {},
    insane: {},
  },
  userScore: {
    perception: 0,
    judge: 0,
    action: 0,
    social: 0,
    individuality: 0,
    insane: 0,
  },
} as CollectionProps

// const root = 'https://api.izuiyou.com/chatbot/v1/ai'
export const getCollection = createAsyncThunk<any, any>(
  'getCollection',
  async (arg, store) => {
    return req(
      '/xai_get_ending_collection',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const getRoleCollection = createAsyncThunk<any, any>(
  'getRoleCollection',
  async (arg, store) => {
    return req(
      '/xai_get_character_memory',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const reportSlice = createSlice({
  name: 'card',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCollection.fulfilled, (state, action) => {
      return {
        ...state,
        collectionList: action.payload.collections,
        collectionMore: action.payload.more,
      }
    })
    builder.addCase(getRoleCollection.fulfilled, (state, action) => {
      return {
        ...state,
        roleCollectionList: action.payload.collections,
        roleCollectionTotal: action.payload.total,
      }
    })
  },
})

export default reportSlice.reducer
